import { Mesh } from "three";

export interface Highlightable {
    highlights: Iterable<Mesh>;
}

export const isHighlightable = (obj: unknown): obj is Highlightable => {
    return obj["highlights"] != null;
}

